(function(){
  (function injectCSS(){
    if(document.getElementById('mmf-css'))return;
    var s=document.createElement('style');
    s.id='mmf-css';
    s.textContent=[
      '@media(max-width:989px){',
      '#MenuCat>li,ul.menu-cat>li{position:relative!important;display:flex!important;flex-wrap:wrap!important;align-items:center!important;padding:18px 16px!important}',
      '#MenuCat>li>a.menu-cat__link,ul.menu-cat>li>a.menu-cat__link{flex:1!important;min-width:0!important;min-height:0!important;height:auto!important;display:flex!important;align-items:center!important;font-size:17px!important;line-height:1.3!important;order:1!important;padding-right:0!important}',
      '#MenuCat>li>span.mobile_togglemenu,ul.menu-cat>li>span.mobile_togglemenu{position:static!important;order:2!important;width:44px!important;flex-shrink:0!important;height:auto!important;display:flex!important;align-items:center!important;justify-content:center!important;top:auto!important;bottom:auto!important;right:auto!important;left:auto!important;inset:auto!important;z-index:auto!important;transform:none!important;padding-right:0!important;transition:none!important;animation:none!important}',
      '#MenuCat>li>.site-nav__dropdown,ul.menu-cat>li>.site-nav__dropdown{width:100%!important;flex-basis:100%!important;flex-shrink:0!important;order:3!important;padding:0!important}',
      '#MenuCat .menu-nav__childlist-item-dropdown{display:flex!important;flex-wrap:wrap!important;align-items:center!important;position:relative!important}',
      '#MenuCat .menu-nav__childlist-item-dropdown>a{flex:1!important;min-width:0!important;order:1!important;padding-right:0!important}',
      '#MenuCat .menu-nav__childlist-item-dropdown>span.mobile_togglemenu{position:static!important;order:2!important;width:44px!important;flex-shrink:0!important;height:auto!important;display:flex!important;align-items:center!important;justify-content:center!important;top:auto!important;bottom:auto!important;right:auto!important;left:auto!important;inset:auto!important;z-index:auto!important;transform:none!important;transition:none!important;animation:none!important}',
      '#MenuCat .menu-nav__childlist-item-dropdown>ul{width:100%!important;flex-basis:100%!important;flex-shrink:0!important;order:3!important}',
      '#MenuCat>li.menu-cat--has-dropdown.toggle>span.mobile_togglemenu::before,#MenuCat .menu-nav__childlist-item-dropdown.toggle>span.mobile_togglemenu::before{font-weight:700!important;font-size:22px!important;line-height:1!important;display:block!important}',
      '.search-header .field,.search-header form .field{display:flex!important;align-items:center!important}',
      '.search-header .field__input,.search-header .search__input{padding-top:0!important;padding-bottom:0!important;height:38px!important;line-height:38px!important;align-self:center!important}',
      '.mm-chips{padding-left:0!important}',
      '}'
    ].join('');
    (document.head||document.documentElement).appendChild(s);
  })();

  if(window.innerWidth>989)return;

  function fixRewardsPill(det){
    var _t;
    function pills(){return['#smile-ui-lite-launcher-frame-container','#smile-ui-lite-container','[id*="smile"][id*="launcher"]','[id*="smile"][id*="container"]'].map(function(s){try{return document.querySelector(s)}catch(e){return null}}).filter(Boolean)}
    function hide(){clearTimeout(_t);pills().forEach(function(el){el.style.setProperty('display','none','important')});if(det.hasAttribute('open')){_t=setTimeout(hide,250)}}
    function show(){clearTimeout(_t);pills().forEach(function(el){el.style.removeProperty('display')})}
    new MutationObserver(function(){det.hasAttribute('open')?hide():show()}).observe(det,{attributes:true,attributeFilter:['open']})
  }

  function fixSingleToggle(el){
    el.style.setProperty('position','static','important');
    el.style.setProperty('order','2','important');
    el.style.setProperty('width','44px','important');
    el.style.setProperty('flex-shrink','0','important');
    el.style.setProperty('height','auto','important');
    el.style.setProperty('display','flex','important');
    el.style.setProperty('align-items','center','important');
    el.style.setProperty('justify-content','center','important');
    el.style.setProperty('transition','none','important');
    el.style.setProperty('animation','none','important');
    el.style.setProperty('top','auto','important');
    el.style.setProperty('bottom','auto','important');
    el.style.setProperty('right','auto','important');
    el.style.setProperty('left','auto','important');
    el.style.setProperty('z-index','auto','important');
    el.style.setProperty('transform','none','important');
    el.style.setProperty('padding-right','0','important');
  }

  function fixSingleCatLink(el){
    el.style.setProperty('flex','1','important');
    el.style.setProperty('min-width','0','important');
    el.style.setProperty('min-height','0','important');
    el.style.setProperty('height','auto','important');
    el.style.setProperty('display','flex','important');
    el.style.setProperty('align-items','center','important');
    el.style.setProperty('font-size','17px','important');
    el.style.setProperty('line-height','1.3','important');
    el.style.setProperty('order','1','important');
    el.style.setProperty('padding-right','0','important');
  }

  function watchToggle(el){
    if(el._mmfWatched)return;
    el._mmfWatched=true;
    fixSingleToggle(el);
    var obs=new MutationObserver(function(){
      obs.disconnect();
      fixSingleToggle(el);
      obs.observe(el,{attributes:true,attributeFilter:['style']});
    });
    obs.observe(el,{attributes:true,attributeFilter:['style']});
  }

  function watchCatLink(el){
    if(el._mmfLinkWatched)return;
    el._mmfLinkWatched=true;
    fixSingleCatLink(el);
    var obs=new MutationObserver(function(){
      obs.disconnect();
      fixSingleCatLink(el);
      obs.observe(el,{attributes:true,attributeFilter:['style']});
    });
    obs.observe(el,{attributes:true,attributeFilter:['style']});
  }

  function watchAllToggles(){
    var sels=[
      '#MenuCat > li > span.mobile_togglemenu',
      'ul.menu-cat > li > span.mobile_togglemenu',
      '#MenuCat .menu-nav__childlist-item-dropdown > span.mobile_togglemenu'
    ];
    sels.forEach(function(sel){
      document.querySelectorAll(sel).forEach(watchToggle);
    });
  }

  function watchAllCatLinks(){
    var sels=[
      '#MenuCat > li > a.menu-cat__link',
      'ul.menu-cat > li > a.menu-cat__link',
      '#MenuCat .menu-nav__childlist-item-dropdown > a'
    ];
    sels.forEach(function(sel){
      document.querySelectorAll(sel).forEach(watchCatLink);
    });
  }

  function applyLayout(){
    var drawer=document.querySelector('#menu-drawer');
    if(!drawer)return;
    var h=window.visualViewport?window.visualViewport.height:window.innerHeight;
    drawer.style.setProperty('height',h+'px','important');
    drawer.style.setProperty('max-height',h+'px','important');
    drawer.style.setProperty('overflow','hidden','important');
    drawer.style.setProperty('overscroll-behavior','none','important');
    var inner=drawer.querySelector('.menu-drawer__inner-container');
    if(inner){inner.style.setProperty('height',h+'px','important');inner.style.setProperty('max-height','none','important');inner.style.setProperty('overflow','hidden','important')}
    var summaryEl=inner?inner.querySelector('summary'):null;
    var sb=summaryEl?summaryEl.offsetHeight:60;
    var navContH=h-sb;
    var navCont=drawer.querySelector('.menu-drawer__navigation-container');
    if(navCont){
      navCont.style.setProperty('position','relative','important');
      navCont.style.setProperty('height',navContH+'px','important');
      navCont.style.setProperty('max-height','none','important');
      navCont.style.setProperty('overflow','hidden','important');
      navCont.style.setProperty('display','grid','important');
      navCont.style.setProperty('grid-template-rows','0px auto','important');
      navCont.style.setProperty('align-content','start','important');
      navCont.style.setProperty('align-items','start','important');
    }
    var util=drawer.querySelector('.menu-drawer__utility-links');
    if(util){util.style.setProperty('display','none','important')}
    var megaNav=drawer.querySelector('nav.menu-drawer__navigation');
    if(megaNav){megaNav.style.setProperty('height','0','important');megaNav.style.setProperty('max-height','0','important');megaNav.style.setProperty('overflow','hidden','important')}
    var vd=document.querySelector('#vertical-drawer');
    if(vd){
      vd.style.setProperty('position','relative','important');
      vd.style.setProperty('width','100%','important');
      vd.style.setProperty('height',navContH+'px','important');
      vd.style.setProperty('max-height',navContH+'px','important');
      vd.style.setProperty('overflow-x','hidden','important');
      vd.style.setProperty('overflow-y','scroll','important');
      vd.style.setProperty('-webkit-overflow-scrolling','touch','important');
      vd.style.setProperty('overscroll-behavior-y','contain','important');
      vd.style.setProperty('z-index','1','important');
    }
    var vb=document.querySelector('#vertical_box');
    if(vb){vb.style.setProperty('height','auto','important');vb.style.setProperty('overflow','visible','important');vb.style.setProperty('display','block','important')}
    var catLis=document.querySelectorAll('#MenuCat > li, ul.menu-cat > li');
    catLis.forEach(function(li){
      li.style.setProperty('position','relative','important');
      li.style.setProperty('display','flex','important');
      li.style.setProperty('flex-wrap','wrap','important');
      li.style.setProperty('align-items','center','important');
      li.style.setProperty('padding','18px 16px','important');
    });
    var catDropdowns=document.querySelectorAll('#MenuCat > li > .site-nav__dropdown, ul.menu-cat > li > .site-nav__dropdown');
    catDropdowns.forEach(function(dd){
      dd.style.setProperty('width','100%','important');
      dd.style.setProperty('flex-basis','100%','important');
      dd.style.setProperty('flex-shrink','0','important');
      dd.style.setProperty('order','3','important');
      dd.style.setProperty('padding','0','important');
    });
    var subLis=document.querySelectorAll('#MenuCat .menu-nav__childlist-item-dropdown');
    subLis.forEach(function(li){
      li.style.setProperty('display','flex','important');
      li.style.setProperty('flex-wrap','wrap','important');
      li.style.setProperty('align-items','center','important');
      li.style.setProperty('position','relative','important');
    });
    var subSubDropdowns=document.querySelectorAll('#MenuCat .menu-nav__childlist-item-dropdown > ul');
    subSubDropdowns.forEach(function(ul){
      ul.style.setProperty('width','100%','important');
      ul.style.setProperty('flex-basis','100%','important');
      ul.style.setProperty('flex-shrink','0','important');
      ul.style.setProperty('order','3','important');
    });
    watchAllToggles();
    watchAllCatLinks();
    var drawerSummary=drawer.querySelector('summary');
    if(drawerSummary){
      drawerSummary.style.setProperty('position','relative','important');
    }
    var closeIcon=drawer.querySelector('summary .icon-close');
    if(closeIcon){
      closeIcon.style.setProperty('opacity','1','important');
      closeIcon.style.setProperty('position','static','important');
      closeIcon.style.setProperty('transform','none','important');
      var closeSpan=closeIcon.parentElement;
      if(closeSpan){
        closeSpan.style.setProperty('position','absolute','important');
        closeSpan.style.setProperty('right','12px','important');
        closeSpan.style.setProperty('top','50%','important');
        closeSpan.style.setProperty('transform','translateY(-50%)','important');
        closeSpan.style.setProperty('width','44px','important');
        closeSpan.style.setProperty('height','44px','important');
        closeSpan.style.setProperty('display','flex','important');
        closeSpan.style.setProperty('align-items','center','important');
        closeSpan.style.setProperty('justify-content','center','important');
      }
    }
    if(!drawer._mmfBound){
      drawer._mmfBound=true;
      drawer.addEventListener('touchmove',function(e){
        var vdEl=document.querySelector('#vertical-drawer');
        if(vdEl&&vdEl.contains(e.target))return;
        e.preventDefault();
      },{passive:false});
    }
  }

  function init(){
    if(!document.body)return;
    watchAllToggles();
    watchAllCatLinks();
    var details=document.querySelector('details.menu-drawer-container');
    if(!details){var all=document.querySelectorAll('details');for(var i=0;i<all.length;i++){if(all[i].querySelector('#vertical-drawer')){details=all[i];break}}}
    if(details)fixRewardsPill(details);
    if(details){
      new MutationObserver(function(){
        if(details.hasAttribute('open')){
          watchAllToggles();
          watchAllCatLinks();
          applyLayout();
        }
      }).observe(details,{attributes:true,attributeFilter:['open']});
    }
    document.addEventListener('click',function(e){
      var t=e.target;
      if(t&&(t.closest('.header__icon--menu')||t.closest('.vertical-menu-title')||t.closest('summary'))){
        watchAllToggles();
        watchAllCatLinks();
        setTimeout(function(){applyLayout();},0);
        setTimeout(applyLayout,200);
        setTimeout(applyLayout,500);
      }
    },true);
    if(window.visualViewport)window.visualViewport.addEventListener('resize',function(){if(window.innerWidth<=989)applyLayout()});
    window.addEventListener('resize',function(){if(window.innerWidth<=989)applyLayout()});
    setTimeout(function(){var det=document.querySelector('details.menu-drawer-container');if(det&&det.open)applyLayout()},300);
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();